import { createContext } from 'react';
import type { DashboardStoreApi } from '../store/useStore';

export const DashboardStoreContext = createContext<DashboardStoreApi | null>(null);
